import React from 'react';
export function EditorialBlock() {
  return <section className="bg-white py-[80px] px-6" data-id="element-42">
      <div className="max-w-[640px] mx-auto" data-id="element-43">
        <h2 className="font-serif text-navy-800 text-[32px] font-bold mb-7" data-id="element-44">
          Here's the simple truth:
        </h2>

        <div className="space-y-[20px] font-sans text-body text-[17px] leading-[1.8]" data-id="element-45">
          <p data-id="element-46">
            You could spend the next few weeks trying to piece together what
            works — testing YouTube routines, asking in forums, reading
            contradicting advice.
          </p>
          <p data-id="element-47">
            Or you could spend $9.87 tonight and have the full protocol, the
            setup checklist, the morning guide, and the consistency tracker
            waiting in your inbox before midnight.
          </p>
          <p data-id="element-48">Everything you need to actually do this is already inside.</p>
          <p className="font-bold text-navy-800" data-id="element-49">
            The only thing left is the decision.
          </p>
        </div>
      </div>
    </section>;
}